<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb"/>
    <form>
      <div class="form-line">
        <div class="line-text" style="font-size: 36px;">{{formData.name || '无'}} </div>
        <div style="height: 20px;position: relative;top: 16px;">{{formData.enterpriseName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系人姓名：</div>
        <div>{{formData.actualName || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系人手机：</div>
        <div>{{formData.phone || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">联系人邮箱：</div>
        <div>{{formData.email || '无'}}</div>
      </div>
      <div class="form-line">
        <div class="line-text">上级：</div>
        <div>{{formData.parentName || '无'}}</div>
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../components/Breadcrumb/Breadcrumb'
  import {errorHandler} from '../../utils/errorHandler'
  import {api} from '../api/User'
  import {bus} from '../../utils/bus'

  export default {
    components: {Breadcrumb},
    name: 'account-detail',
    data () {
      return {
        breadcrumb: [{
          value: '用户中心',
          name: 'account-management'
        }, {
          value: '用户详情'
        }],
        formData: {},
        currentCode: ''
      }
    },
    created () {
      this.currentCode = bus.global.accountCode
      this.getAccountByCode()
    },
    methods: {
      getAccountByCode () {
        this.$axios.get(`${api.getAccountByCode}/${this.currentCode}`, {})
          .then(res => {
            if (res.data.retCode === 1) {
              let data = res.data.data
              this.formData = data
            }
          })
          .catch(errorHandler('获取账号信息失败'))
      },
    }
  }
</script>

<style scoped>
  form {
    width: 1000px;
    margin: 40px 0 0 0;
    text-align: left;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: center;
  }
  .form-line div {
    width: 300px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
    width: 200px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 124px;
    margin: 40px auto 0;
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/view/User/AccountDetail.vue